import React from 'react'
import PropTypes from 'prop-types'
import { FieldWrapper, Select } from '@morningtrain/react-fields'
import { ExecuteOperationOnPipe, ModelContext } from '@morningtrain/react-resources'
import useFirms from 'support/hooks/use-firms'
import useFirm from 'support/hooks/use-firm'
import useFirmId from 'support/hooks/use-firm-id'
import { useTranslation } from '@morningtrain/react-translations'
import useSelectedFirmIds from 'support/hooks/use-selected-firm-ids'
import {Pipeline, TriggerPipelineOnCallback, WhenIsPiping} from '@morningtrain/react-pipelines'
import RefreshPagePipe from "widgets/auth/RefreshPagePipe";

function GlobalFirmFilter (props) {
  const [firm, setFirm] = useFirm()
  const [firmIds, setFirmIds] = useSelectedFirmIds()
  const [defaultFirmId] = useFirmId()
  const [value, setValue] = React.useState(defaultFirmId)

  const [firms] = useFirms()

  const options = firms.map((val, index) => {
    return {
      value: val.id,
      label: val.name
    }
  })

  React.useEffect(() => {
    if (value === null) {
      setFirm(null)

      const allIds = []

      firms.forEach(firmEntry => {
        allIds.push(firmEntry.id)
      })

      setFirmIds(allIds)
    } else {
      setFirmIds([value])

      const currentlySelectedFirmId = firm !== null ? firm.id : null

      if (parseInt(currentlySelectedFirmId) !== parseInt(value)) {
        firms.forEach(firmEntry => {
          if (parseInt(firmEntry.id) === parseInt(value)) {
            setFirm(firmEntry)
          }
        })
      }
    }
  }, [value, firms])

  const placeholder = useTranslation(props.withoutAllDepartments === true ? 'generic.select_firm' : 'generic.all_firms')

  const callbackRef = React.useRef(null)

  const updateCallbackRef = (callback) => {
    callbackRef.current = callback
  }

  const handleChange = selectedValue => {
    if (props.withoutAllDepartments === true && !selectedValue) {
      return
    }
    setValue(selectedValue)
    if (callbackRef.current && typeof callbackRef.current === 'function') {
      callbackRef.current({ firm_id: selectedValue })
    }
  }

  return (
    <ModelContext.Provider value={firm}>
      {options.length > 1
        ? (
          <FieldWrapper className={props.wrapperClassName}>
            <Select
              placeholder={placeholder}
              name='id'
              className={props.className}
              options={options}
              naked
              onChange={handleChange}
            />
          </FieldWrapper>
          )
        : null}
      <Pipeline>
        <TriggerPipelineOnCallback callback={updateCallbackRef} />
        <ExecuteOperationOnPipe
          namespace='api'
          resourceName='env.firms'
          operationName='select'
          data={
            payload => {
              return { firm: payload.firm_id }
            }
          }
        />
        <ExecuteOperationOnPipe
          namespace='api'
          resourceName='env.departments'
          operationName='departments'
        />
        <WhenIsPiping>
          <RefreshPagePipe />
        </WhenIsPiping>
      </Pipeline>
    </ModelContext.Provider>
  )
}

GlobalFirmFilter.defaultProps = {
  label: null,
  placeholder: null
}

GlobalFirmFilter.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  icon: PropTypes.node
}

export default GlobalFirmFilter
